<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<!-- <el-form :inline="true" class="demo-form-inline" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
						
						</template>
					</el-form-item>
				</el-form> -->
                <el-button type="primary" @click="add">修改单价</el-button>
			</header>
		</div>
		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="id" label="序号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="integralId" label="积分ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="integralName" label="名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="storeType" label="店铺类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.storeType==0">线上店铺</p>
					<p v-if="scope.row.storeType==1">九天小超</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="integralLogo" label="LOGO" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.integralLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="maxPrice" label="最高价" sortable align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<span>￥{{ scope.row.maxPrice }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="minPrice" label="最低价"  sortable align="center" :show-overflow-tooltip="true">
                 <template slot-scope="scope">
					<span>￥{{ scope.row.minPrice }}</span>
				</template>
			</el-table-column>
            <el-table-column prop="newPrice" label="昨日收盘价" sortable align="center" :show-overflow-tooltip="true">
                 <template slot-scope="scope">
					<span>￥{{ scope.row.newPrice }}</span>
				</template>
			</el-table-column>
            <el-table-column prop="dayPrice" label="当日参考价" sortable align="center" :show-overflow-tooltip="true">
                 <template slot-scope="scope">
					<span>￥{{ scope.row.dayPrice }}</span>
				</template>
			</el-table-column>
            <el-table-column prop="reference" label="参考汇率"  align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<p v-if="scope.row.reference==0">USDT</p>
					<p v-if="scope.row.reference==1">CNY</p>
				</template>
            </el-table-column>
			<el-table-column prop="updateDate" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column  label="操作"  fixed="right"  width="160px" align="center">
				　<template slot-scope="scope">
					<el-button size="small" type="text" @click="del(scope.row.id)">删除</el-button>
					<!-- <el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id)">
						<el-button size="small" type="text" slot="reference" >删除</el-button>
					</el-popconfirm> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 修改价格 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" title="修改" :visible.sync="dialogVisibleAdd" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="请选择用户">
							<el-input type="text"  v-model="userName"
									placeholder="请输入用户名称(搜索条件)" @input="inputHandler" clearable />
					    </el-form-item>
					</div> -->
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="类型">
							<el-select clearable filterable v-model="storeInfo.integralId" placeholder="请选择类型"
							style="width:150px;">
								<el-option v-for="item in storeLevelList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="参考汇率">
							<el-select clearable filterable v-model="storeInfo.reference" placeholder="请选择汇率"
							style="width:150px;">
								<!-- <el-option v-for="item in storeLevelList" :key="item.id" :label="item.name"
										:value="item.id"></el-option> -->
								<el-option key="0" label="USDT" value="0"></el-option>
								<el-option key="1" label="CNY" value="1"></el-option>
							</el-select>
						</el-form-item>
					</div>	
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="最高价格">
							<el-input type="number" v-model="storeInfo.maxPrice" placeholder="请输入价格" />
						</el-form-item>
						<el-form-item label="最低价格">
							<el-input type="number" v-model="storeInfo.minPrice" placeholder="请输入价格" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="昨日收盘价">
							<el-input type="number" v-model="storeInfo.newPrice" placeholder="请输入价格" />
						</el-form-item>
						<el-form-item label="当日参考价">
							<el-input type="number" v-model="storeInfo.dayPrice" placeholder="请输入价格" />
						</el-form-item>
					</div>
					<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="详细地址">
							<el-input type="text" v-model="storeInfo.address" placeholder="请输入详细地址" />
						</el-form-item>
					</div> -->
					
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisibleAdd = false">取 消</el-button>
				<el-button type="primary" @click="sure">确认</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('otc');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				loading: false,
				storeList: [{}], //列表
				dialogVisibleAdd:false,
				storeInfo: {
					maxPrice: "",
					minPrice: "",
					// integralName: "",
					integralId:'',
					reference:'',
					newPrice:'',
					dayPrice:''
				},
                page: {
					pageNum: 1,
					pageSize: 10
				},
				storeLevelList:{}
			};
		},
		watch: {

		},
		methods: {
			//新增商品
			sure() {
				let data = Object.assign(this.storeInfo)
				console.log('修改单价--',this.storeInfo);
				this.$api.addPriceUpd(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleAdd = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
						this.dialogVisibleAdd = false;
					}
				})

			},					
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreList()
			},
			getStoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize
				}

				this.$api.getOtcPriceChangeList(data).then((res) => { //
				// res.data=JSON.parse(this.$decrypt(res.data)).data
					console.log('价格变动列表:', res.data.list);
					if (res.state == 'success') {
						this.storeList = res.data
						// console.log(this.storeList)
						this.loading = false
					}
				})
			},
			getType(){
				this.$api.getIntegralList(this.$encrypt({})).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.storeLevelList = res.data
					}
					console.log('资产类型--', res);
				})
			},
			add() {
				this.dialogVisibleAdd = true;
				this.storeInfo = {}
				this.getType();
			},
			del(id){
				this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delPriceUpd(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getStoreList();
						}else{
							this.$message.error(res.message);
						}
						
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		},

		created() {
			this.getStoreList();
			
		}

	};
</script>

<style scoped="scoped">
    .header_nav{
        padding: 30px 0 30px 30px;
    }
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.searchBox {
		position: absolute;
		top: 50px;
		left: 0;
		z-index: 99;
		width: 232px;
		height: 100px;
		background: #fff;
		box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
		overflow: auto;
		
	}
</style>
